module.exports = __webpack_public_path__ + "assets/a533d86e62006672fbeca7719968d308.png";